import DOMPurify from "dompurify";
import BaseModal from "./BaseModal";

const TaskNotesModal = ({ modalNote, open, onClose }) => {
  if (!open) return null;

  return (
    <BaseModal title="Notes" onClose={onClose} open={open}>
      {modalNote ? (
        <div className="reflection-modal-body">
          <div
            className="text-body-b2 mb-0 text-justify"
            style={{ color: "#C8CED3" }}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(modalNote),
            }}
          ></div>
        </div>
      ) : (
        <div className="reflection-modal-body">
          <p className="text-body-b2 mb-0" style={{ color: "#9AA6B2" }}>
            No notes available to show.
          </p>
        </div>
      )}
    </BaseModal>
  );
};

export default TaskNotesModal;
